class OrderTracking extends HTMLElement {

    connectedCallback() {
        this.apiUrl = 'https://animal-pack-tracking.rene-a7d.workers.dev/'
        this.form = this.querySelector('form');
        this.resultContainer = this.querySelector('[data-result]');
        if (!this.form) {
            console.error('OrderTracking: <form> not found inside component');
            return;
        }
        this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const data = {
            order_number: formData.get('order_number'),
            last_name: formData.get('last_name'),
            zip: formData.get('zip'),
        };

        this.showMessage('Loading…');
        try {
            const res = await fetch(this.apiUrl, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error(`Tracking not found`);
            const json = await res.json();
            this.renderResult(json);
        } catch (err) {
            this.showMessage(`${err.message}`);
        }
    }

    showMessage(msg) {
        if (this.resultContainer) {
            this.resultContainer.innerHTML = `
        <div class="p-5 md:p-10 flex justify-center">
            <span>${msg}</span>
        </div>
        `;
        }
    }

    renderResult({order_number, placed_at, total, items, tracking}) {
        if (!this.resultContainer) return;

        const itemRows = items.map(i => `
        <li class="grid grid-cols-3 gap-2 py-1">
          <div>${i.title}</div>
          <div class="w-10 text-center">${i.quantity}</div>
          <div class="text-right">${i.price}</div>
        </li>
      `).join('');

        let trackingRows = '';
        if (tracking.length > 0) {
            trackingRows = tracking.map(t => `
          <li class="py-2 flex flex-col gap-2">
            <div class="flex justify-between items-center">
            <span class="font-semibold">Carrier:</span>
            <span>${t.carrier || '—'}</span>
          </div>
          <div class="flex flex-col md:flex-row justify-between md:items-center">
            <span class="font-semibold">Tracking Number:</span>
            <a target="_blank" rel="noopener" href="${t.tracking_url}" class="mt-2 underline">${t.tracking_number || '—'}</a>
          </div>
        </li>
        <li class="flex col-span-full justify-center items-center py-5">
        ${t.tracking_url ? `
            <div class="mt-1">
              <a href="${t.tracking_url}" target="_blank" rel="noopener" class="btns button button-light tracking-button flex justify-center items-center">
                Track Package
              </a>
            </div>
          ` : ''}
        </li>
      `).join('');
        } else {
            trackingRows = '<li class="p-5 flex flex-col gap-2">Tracking information is not available</li>';
        }

        const html = `
        <div class="flex justify-between items-center border-b border-gray-200 p-5">
          <div class="flex flex-col">
            <span class="text-sm text-gray-500">Order Number</span>
            <span class="text-lg md:text-2xl font-bold">${order_number}</span>
          </div>
          <div class="flex flex-col items-end">
            <span class="text-sm text-gray-500">Date Placed</span>
            <span>${new Date(placed_at).toLocaleString()}</span>
          </div>
        </div>
        <div class="border-b border-gray-200 p-5">
          <ul>
            <li class="grid grid-cols-3 gap-2 py-2 font-semibold text-gray-600">
              <div>Item</div>
              <div class="w-10 text-center">Qty</div>
              <div class="text-right">Price</div>
            </li>
            ${itemRows}
          </ul>
          <p class="mt-2 text-lg font-bold text-right">Total: ${total}</p>
        </div>
        <div class="p-5">
          <span class="text-2xl font-bold">Tracking Information</span>
          <ul class="mt-2 list-none gap-2">
            ${trackingRows}
          </ul>
        </div>
      `;

        this.resultContainer.innerHTML = html;
    }
}

customElements.define('order-tracking', OrderTracking);